/**
 * Created by craser on 4/28/15.
 *
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.call(this);
};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize,
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone,
	"com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone"
);

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.bindListeners = function() {
	/** @type {HTMLElement} */
	var stageDiv = com.inq.ui.Stage.getStageElement();
	com.inq.utils.Capabilities.BindListener(stageDiv, "mousedown", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onMouseDown);
	com.inq.utils.Capabilities.BindListener(stageDiv, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchStart);
	com.inq.utils.Capabilities.BindListener(stageDiv, "touchend", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchEnd);
	com.inq.utils.Capabilities.BindListener(stageDiv, "touchmove", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchMove);

	["txtInput", "emailInput"].forEach(function(inputName) {
		var container = Application.application.getTextInput(inputName);
		if (!container) return;
		var input = container.getInput();
		if (input) {
			com.inq.utils.Capabilities.BindListener(input, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.BindListener(input, "activate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.BindListener(input, "deactivate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
			com.inq.utils.Capabilities.BindListener(input, "paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
		}
	});

	var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if(txtInput != null) {
		txtInput.setFocus();
	}
};


com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.unbindListeners = function() {
	var /** @type {HTMLElement} */ stageDiv = com.inq.ui.Stage.getStageElement();
	com.inq.utils.Capabilities.UnbindListener(stageDiv, "mousedown", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onMouseDown);
	com.inq.utils.Capabilities.UnbindListener(stageDiv, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchStart);
	com.inq.utils.Capabilities.UnbindListener(stageDiv, "touchend", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchEnd);
	com.inq.utils.Capabilities.UnbindListener(stageDiv, "touchmove", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onTouchMove);

	["txtInput", "emailInput"].forEach(function(inputName) {
		var container = Application.application.getTextInput(inputName);
		if (!container) return;
		var input = container.getInput();
		if (input) {
			com.inq.utils.Capabilities.UnbindListener(input, "touchstart", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.UnbindListener(input, "activate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.UnbindListener(input, "deactivate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
			com.inq.utils.Capabilities.UnbindListener(input, "paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
		}
	});
};

/***
 * binding windows event to xfrom controls
 * @param dtid
 * @param fields
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.bindOrbeonListeners = function(dtid, fields) {
	/** @type {number} */
	var ix = 0;
	while(ix < fields.length) {
		/** @type {js.HtmlDom} */
		var el = fields[ix];
		++ix;
		if(el != null) {
			com.inq.utils.Capabilities.BindListener(el,"activate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
			com.inq.utils.Capabilities.BindListener(el,"deactivate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
			com.inq.utils.Capabilities.BindListener(el,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
		}
	}
	this.orbeonDtidMap[dtid] = fields;
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.unbindOrbeonListeners = function(dtid) {
	/** @type {number} */
	var ix = 0;
	var fields = this.orbeonDtidMap[dtid];
	if (fields && fields.length>0) {
		while(ix < fields.length) {
			/** @type {js.HtmlDom} */
			var  el = fields[ix];
			++ix;
			if(el != null) {
				com.inq.utils.Capabilities.UnbindListener(el,"activate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus);
				com.inq.utils.Capabilities.UnbindListener(el,"deactivate", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur);
				com.inq.utils.Capabilities.UnbindListener(el,"paste", com.inq.flash.client.chatskins.ChatTextFocusMonitor.onPaste);
			}
		}
		this.orbeonDtidMap[dtid] = null;
	}
};

/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 1) disable the scroll monitor, it messes us up for our sizing of the viewport
 *	 2) If we have focus and on iphone or ipad, we want to
 *		2a) scroll to the bottom, this requires us to:
 *			* change the clients body style to allow us to scroll down, we change the minHeight and minWidth
 *			* to set listener for scroll the scroll down.
 *			* At completion of scroll down, get viewport and restore body minHeight and minWidth
 *			* Reenable scroll monitor
 *	3) No focus,
 *		get viewport size
 *		reenable scroll monitor
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function resizeToViewport():Void
 * @public
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.resizeToViewport = function(from) {
	// If chat is minimized, I do not want to resize chat.
	if (this.bResizeToViewport || com.inq.flash.client.control.MinimizeManager.minimized)
		return;
	this.bResizeToViewport = true;
	/** @type {Window} */
	var clientWin = window.top;

	// if its a device with a virtual keyboard and we are responding to focus event ( on a text input ).. we are resizing to make room for keybd
	if (this.hasFocus) {
		this.resizeToViewportImpl();
	}
	else {
		this.zoomViewport(clientWin);
		com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
		try {
			var viewPort = com.inq.utils.Capabilities.getViewport();
			Application.SetArea(viewPort);
			Application.Resize();
			this.bResizeToViewport = false;
		} catch (err) {
			haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplBase.js", lineNumber : 111, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase", methodName : "resizeToViewport"});
		}
	}
};

/**
 * Prevent mousedown events from propagating.
 *
 * Stopping this event by listening for mousedown events (instead of touchstart) prevents
 * the re-centering/focus scrolling when we call focus() later in onTouchEnd. (See RTDEV-11549.)
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onMouseDown = function(ev) {
	if (com.inq.flash.client.chatskins.ChatTextFocusMonitor.HasFocus() && (ev.target != this.focusElement)) {
		ev.preventDefault();
		ev.stopPropagation();
	}
};

/**
 * onTouchStart - Prevent the text area from losing focus if/when buttons are clicked.
 *
 * @private
 * @see onTouchEnd
 * @see onFocus
 * @param {Event} ev
 * @param {HTMLElement} element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onTouchStart = function(ev, element) {
	/* We want to see if we are touching a button
	 * So we get the element we will check the container attribute (we added this attribute in container.js)
	 * If we are focused && Windows Phone && container is a button then we want to fire the click event and swallow the touch event
	 *
	 * We want to do this so we do not loose focus and drop the virtual keyboard
	 */
	if (this.hasFocus) {
		/** @type {com.inq.ui.Button} */
		var possibleButton = ev.target.container;
		if (possibleButton) {
			if (js.Boot.__instanceof(possibleButton, com.inq.ui.Button)) {
				ev.preventDefault();
				ev.stopPropagation();
				possibleButton.softClick();
				this.keepFocus = true;
			}
		}
		else {
			ev.preventDefault();
			ev.stopPropagation();
		}
	}
	/* super.onTouchStart */
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.__super__.prototype.onTouchStart.call(this,ev);
};

/**
 * Listen for touchmove events, and prevent them from causing the text entry area to lose focus. (The Windows
 * Phone TextArea code handles scrolling, so we're not interfering with that.)
 * @param ev
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onTouchMove = function(ev) {
	this.keepFocus = this.hasFocus;
	ev.preventDefault();
	ev.stopPropagation();
};

/**
 * Listen for touchend events, and determine whether to let the input element lose focus.
 * If the keepFocus flag is set, we do what we can to make sure that the current focusElement
 * keeps focus. Otherwise, we check to see if we already have focus, and whether the touch
 * target is the focusElement, and determine whether to focus or blur.
 * @param ev
 * @returns {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onTouchEnd = function(ev) {
	if (this.keepFocus) {
		this.keepFocus = false;
		if (this.focusElement) {
			var self = this;
			setTimeout(function() {
				self.focusElement.focus();
			}, 1);
		}
	}
	else if (this.hasFocus) {
		var self = this;
		if (this.focusElement != ev.target) {
			setTimeout(function() {
				self.focusElement.blur();
			}, 1);
		}
		else {
			setTimeout(function() {
				self.focusElement.focus();
			}, 1);
		}
	}
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.__super__.prototype.onTouchEnd.call(this,ev);
};

/**
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 *
 * @public
 * @param {FocusEvent} ev
 * @param {HTMLElement) element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onFocusImpl = function(ev, element) {
	/*  If we try to re-scroll the window in the same thread, we */
	/*  get ignored. This waits for the OS-driven zooming and */
	/*  scrolling to finish.  FIXME: I'd LOVE to find a more robust */
	/*  method of timing/chaining this. */
	this.focusElement = element;
	this.bindOrientationListener();
	this.focusToken = null;
	/** @type {com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone} */
	var self = this;

	// Viewport dimensions (as returned by Capabilities.getViewport()) lag significantly behind UI changes.
	// (As much as 800-1500ms.) And as far as I can tell, binding to scroll or resize events does not
	// yield acceptable results. (We get *many* scroll events, and *no* resize.)
	com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(500), 200, function () {
		self.FixIPhoneFocusScroll();
		self.resizeToViewport("ChatTextFocusMonitorImplWindowsPhone.onFocusImpl");
	}, 15, 3);

	return true;
};

/**
 * onBlurImpl - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @static
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.onBlurImpl = function (ev) {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.prototype.onBlurImpl.apply(this, arguments);
	var self = this;
	com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(500), 200, function () {
		self.resizeToViewport("ChatTextFocusMonitorImplWindowsPhone.onBlurImpl");
	}, 15, 3);
	return true;
};

/** @type {boolean} */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplWindowsPhone.prototype.keepFocus = false;

